export default {
  data() {
    return {
      //
    }
  },
  computed: {
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    linkasSklypas() {
      return 'SKLYPO_UZSAKYMAS'
    },
  },
  methods: {
    parseLinkas(message) {
      let linkas = null

      if (message.includes(`<${this.linkasSklypas}>`)) {
        linkas = { value: this.linkasSklypas, text: 'Užsakyti' }
      }

      return linkas
    },
    cleanMessage(message) {
      return message.replace(`<${this.linkasSklypas}>`, '')
    },
    gotoLinkas(linkas) {
      if (linkas === this.linkasSklypas) {
        this.newZemesSklypas()
      }
    },
    newZemesSklypas() {
      if (this.isLocal) {
        this.$router.push({
          name: 'pazymosZemesSklypas',
        })
        return
      }
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=160`
    },
  },
}
